import { c as _c } from "react/compiler-runtime";
interface BookmarkIconProps {
  size?: number;
  isSelected: boolean;
}
const BookmarkIcon = t0 => {
  const $ = _c(8);
  const {
    size: t1,
    isSelected
  } = t0;
  const size = t1 === undefined ? 16 : t1;
  const t2 = `dynamic-size ${isSelected ? "text-primary-600" : "text-white"}`;
  let t3;
  if ($[0] !== size) {
    t3 = {
      "--width": size,
      "--height": size
    };
    $[0] = size;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = t3 as React.CSSProperties;
  const t5 = `${isSelected ? "currentColor" : "black"}`;
  let t6;
  if ($[2] !== t5) {
    t6 = <path d="M3.99969 1.93262H11.9997C12.4015 1.93262 12.7329 2.2642 12.7331 2.66602V14C12.733 14.0264 12.72 14.0482 12.6989 14.0605L12.6911 14.0654C12.6978 14.0614 12.6993 14.0619 12.6931 14.0635C12.6867 14.0651 12.6772 14.0664 12.6667 14.0664C12.6562 14.0664 12.6467 14.0651 12.6403 14.0635C12.6341 14.0619 12.6356 14.0614 12.6423 14.0654L12.6315 14.0586L8.29852 11.5791C8.13703 11.4867 7.94271 11.4747 7.77313 11.5439L7.70184 11.5791L3.36884 14.0586L3.36493 14.0605C3.34461 14.0722 3.32175 14.0723 3.30145 14.0605C3.28021 14.0482 3.2664 14.0265 3.2663 14V2.66602C3.26648 2.26431 3.59799 1.9328 3.99969 1.93262Z" stroke={t5} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== t2 || $[5] !== t4 || $[6] !== t6) {
    t7 = <svg className={t2} style={t4} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">{t6}</svg>;
    $[4] = t2;
    $[5] = t4;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
};
export default BookmarkIcon;